import { Box, Button, Image, Keyboard, Text, TextInput } from "grommet";
import React, { useContext, useEffect, useState } from "react";
import { withRouter } from "react-router";

import AuthContext from "../context/AuthContext";

import { auth } from "firebase";

const Login = ({ history }) => {
  // Declare a new state variable, which we'll call "count"
  const [username, setUser] = useState("");
  const [password, setPass] = useState("");
  const [email, setEmail] = useState("");
  const [wrongPass, setWrongPass] = useState(false);
  const [wrongUser, setWrongUser] = useState(false);
  const [checking, setChecking] = useState(false)
  const [error, setError] = useState(false)
  const [success, setSuccess] = useState(false)
  const [reset, setReset] = useState(false)

  const { authFunctions, userData, state, tenant } = useContext(AuthContext)

  const signIn = async () => {
    setChecking(true)
    authFunctions.signIn({ identifier: username, password }).then(res => {
      setChecking(false)
    })

  }

  useEffect(() => {
    if (state.authed) {
      userData?.role === "Admin" || userData?.role === "Teacher" && history.replace(`${process.env.PUBLIC_URL}/${tenant.url}/smartlearning/courses`);
    } else {

    }
  }, [state])

  const resetFunc = () => {
    auth().sendPasswordResetEmail(email).then((a) => {
      // Email sent.
      setSuccess("El correo electrónico se ha enviado correctamente. Revisa tu bandeja de entrada, en breves momentos podrás recuperar tu contraseña.")
      setEmail("")
      setReset(!reset)
    }).catch((error) => {
      // An error happened.
      setError(error)
    });
  }


  return (
    <Box fill="vertical" flex={"grow"} justify="center" background={{ color: "black", image: "url(https://source.unsplash.com/random/?landscape,night)", size: "cover" }} style={{ position: "relative" }}>
      <Box background="black" style={{ zIndex: 1, opacity: .5, position: "absolute", top: 0, left: 0, right: 0, bottom: 0, height: "100%", width: "100%" }} />
      <Box background="#F4F6F9" style={{ zIndex: 2 }} elevation="large" fill="vertical" width="medium" height="medium" justify="center" round={{ size: "small", corner: "right" }} gap="small" pad="small">
        <Box >
          <Image fit="cover" src="../login.svg" />
        </Box>
        <Keyboard onEnter={() => !reset ? signIn() : resetFunc()} >
          <Box gap="small" justify="center" >
            {!reset ? <Box gap="small">
              <TextInput
                id="user"
                type="text"
                value={username}
                placeholder="Email..."
                onChange={event => {
                  setUser(event.target.value);
                  setWrongPass(false);
                }}

              />
              <TextInput
                id="pass"
                type="password"
                value={password}
                placeholder="Contraseña..."
                onChange={event => {
                  setPass(event.target.value);
                  setWrongPass(false);
                }}
              />
            </Box> : <TextInput
                id="email"
                type="email"
                value={email}
                placeholder="Email"
                onChange={event => setEmail(event.target.value)}
              />}

            <Button disabled={checking} onClick={() => !reset ? signIn() : resetFunc()} primary color="brand" label={!reset ? (checking ? "Accediendo..." : "Acceder") : "Recuperar contraseña"} />

            {error !== false && (
              <Box onClick={() => setError(false)}>
                <Text>{error}</Text>
              </Box>
            )}

            {success !== false && (
              <Box onClick={() => setSuccess(false)}>
                <Text color="#4BB543">{success}</Text>
              </Box>
            )}

            <Box align="center" onClick={() => setReset(!reset)}>
              <Text>{!reset ? "Recuperar Contraseña" : "Login"}</Text>
            </Box>

          </Box>
        </Keyboard>
      </Box>

    </Box>
  );
};

export default withRouter(Login);
